import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { AbstractModalWithResult } from 'src/app/shared/components/abstract-modal-with-result';

import { ArchiveAndOtherActionsService } from '../../../task-process/archive-and-other-actions/archive-and-other-actions.service';
import { ModerationAction } from '../../../task-process/archive-and-other-actions/models';

@Component({
  selector: 'app-select-moderation-action-popover',
  templateUrl: './select-moderation-action-popover.component.html',
  styleUrls: ['./select-moderation-action-popover.component.scss'],
})
export class SelectModerationActionPopoverComponent
  extends AbstractModalWithResult<ModerationAction>
  implements OnInit
{
  static modalId = 'SelectModerationActionPopoverComponent';

  @Input() messageId: number;
  @Input() siteId: number;

  actions: ModerationAction[] = [];
  loading = true;

  constructor(
    popoverController: PopoverController,
    private archiveAndOtherActionsService: ArchiveAndOtherActionsService
  ) {
    super(popoverController);
  }

  ngOnInit() {
    this.archiveAndOtherActionsService
      .getModerationActions(this.messageId, this.siteId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: response => (this.actions = response),
      });
  }

  getModalId() {
    return SelectModerationActionPopoverComponent.modalId;
  }
}
